/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {FilterType} from "../../../../data/finders.model";
import {connect} from "react-redux";
import {getTagMap} from "../../../../selectors/tags";
import {createSelector} from 'reselect';
import {toggleTag} from "../../../../actions/finder";
import CheckboxPanelSection from "../../../molecules/finder/CheckboxPanelSection";
import {TagList} from "../../../molecules/finder/TagList";
import {ShowHide} from "../../../atoms/layout/ShowHide";
import Block from "../../../atoms/layout/Block";


class SidepanelCheckboxesPanel extends React.Component {

    static propTypes = {
        filter: PropTypes.oneOfType([PropTypes.shape(FilterType), PropTypes.any]),
        sections: PropTypes.array,
        selected: PropTypes.array,

        closeFinderPanel: PropTypes.func,
        toggleTag: PropTypes.func,
    };

    onTagSelect = (tagId) => this.props.toggleTag({ filterIndex: this.props.filter.index, tag: tagId });

    render() {
        const {filter, selected, rootTag} = this.props;

        if (!filter || !rootTag) {
            return null;
        }

        const nestedTags = rootTag.children.filter(tag => tag.children.length > 0).map(tag => ({ tag }));
        const orphanTags = rootTag.children.filter(tag => tag.children.length === 0);

        return <React.Fragment>
            <span className="p-filter-container__aside-panel-selected-tag-title">
                {rootTag.title}
            </span>

            <ShowHide show={orphanTags.length > 0}>
                <hr className="p-filter-container__aside-panel-body-separator" />
                <Block className="p-filter-container__aside-panel-body__orphan-tags">
                    <TagList tags={orphanTags} selected={selected} onTagSelect={this.onTagSelect}/>
                </Block>
            </ShowHide>

            <ShowHide show={nestedTags.length > 0}>
                <hr className="p-filter-container__aside-panel-body-separator" />
                <CheckboxPanelSection filterIndex={filter.index} tags={nestedTags} selected={selected} toggleTag={this.onTagSelect}/>
            </ShowHide>
        </React.Fragment>
    }

}

const mapStateToProps = () => {
    const rootTagSelector = createSelector(
        getTagMap,
        (state, ownProps) => ownProps.filter.tag,
        (tags, root) => tags[root] || null
    );

    return (state, ownProps) => ({ rootTag: rootTagSelector(state, ownProps) });

};

export default connect(mapStateToProps, { toggleTag })(SidepanelCheckboxesPanel);
